import React from 'react';
import { ArrowRight } from 'lucide-react';
import Button from '../ui/Button';

// Confirmation shown before a stop edit (field change and/or drag reposition)
// is written to the database.
export default function ConfirmUpdateStopDialog({ confirm, saving, onCancel, onConfirm }) {
  if (!confirm) return null;

  return (
    <div className="fixed inset-0 z-[2000] flex items-center justify-center bg-slate-900/30 backdrop-blur-[2px] animate-fade-in">
      <div className="w-[440px] max-w-[92vw] bg-white rounded-xl shadow-pop border border-slate-200 p-5 animate-slide-up">
        <h3 className="text-[16px] font-semibold text-slate-900">Save changes to this stop?</h3>
        <p className="text-[12.5px] text-slate-500 mt-1">
          Review the changes below — they will be saved to the database.
        </p>

        <div className="mt-3 rounded-md border border-slate-200 bg-slate-50 px-3 py-3 text-[12.5px] text-slate-700 space-y-2">
          {confirm.nameChanged ? (
            <div className="flex items-center gap-2">
              <span className="font-semibold text-slate-500 w-20 shrink-0">Name</span>
              <span className="text-slate-400 line-through truncate">{confirm.prevName || '—'}</span>
              <ArrowRight className="h-3 w-3 text-slate-300 shrink-0" />
              <span className="font-medium text-slate-900 truncate">{confirm.name}</span>
            </div>
          ) : (
            <div className="flex items-center gap-2">
              <span className="font-semibold text-slate-500 w-20 shrink-0">Name</span>
              <span className="font-medium">{confirm.name}</span>
            </div>
          )}

          {confirm.moved ? (
            <div className="flex items-center gap-2">
              <span className="font-semibold text-slate-500 w-20 shrink-0">Position</span>
              <span className="font-mono text-slate-400 line-through truncate">
                {Number(confirm.prevLat).toFixed(6)}, {Number(confirm.prevLng).toFixed(6)}
              </span>
              <ArrowRight className="h-3 w-3 text-slate-300 shrink-0" />
              <span className="font-mono font-medium text-slate-900 truncate">
                {Number(confirm.lat).toFixed(6)}, {Number(confirm.lng).toFixed(6)}
              </span>
            </div>
          ) : (
            <div className="flex items-center gap-2">
              <span className="font-semibold text-slate-500 w-20 shrink-0">Position</span>
              <span className="font-mono">
                {Number(confirm.lat).toFixed(6)}, {Number(confirm.lng).toFixed(6)}
              </span>
            </div>
          )}
        </div>

        <div className="mt-4 flex items-center justify-end gap-2">
          <Button variant="ghost" size="md" onClick={onCancel} disabled={saving}>
            Cancel
          </Button>
          <Button variant="primary" size="md" loading={saving} onClick={onConfirm}>
            Confirm &amp; save
          </Button>
        </div>
      </div>
    </div>
  );
}
